import {
  TERMS_ACTION_START,
  TERMS_ACTION_ERROR,
  GET_ALL_TERMS,
  GET_TERMS,
  CREATE_TERMS,
  EXPIRE_TERMS,
  ACTIVATE_TERMS,
} from './actions';

const initialState = {
  loading: false,
  error: null,
  terms: [],
  activeTerms: null,
};

const termsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TERMS_ACTION_START:
      return { ...state, loading: true, error: null };
    case TERMS_ACTION_ERROR:
      return { ...state, loading: false, error: action.payload };
    case GET_ALL_TERMS:
      return { ...state, loading: false, terms: action.payload };
    case GET_TERMS:
      return { ...state, loading: false, activeTerms: action.payload };
    case CREATE_TERMS:
      return { ...state, loading: false, terms: [...state.terms, action.payload] };
    case EXPIRE_TERMS:
      return {
        ...state,
        loading: false,
        terms: state.terms.map((t: any) => (t.id === action.payload ? { ...t, expired: true } : t)),
      };
    case ACTIVATE_TERMS:
      return {
        ...state,
        loading: false,
        terms: state.terms.map((t: any) => (t.id === action.payload ? { ...t, active: true } : t)),
      };
    default:
      return state;
  }
};

export default termsReducer; 